export const Default = {
    0: '否',
    1: '是',
};

// 关联类型
export const RelateType = {
    ACCURACY: '准确关联',
    TEMPORARY: '临时关联',
};


// WEBPACK FOOTER //
// ./src/components/site/researchCenterDetail/constants.js